import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Asset from './asset/asset';
import GenerateQR from './asset/generateQR';
import GenerateQRAssociates from './associates/generateQRAssociates';
import Bulk from './associates/bulk';
import Vendor from './vendor/vendor';
import Category from './category/category';
import Associates from './associates/associates';
import Login from './login';
import Allocation from './allocation/allocation';
import AllocationHistory from './allocation/allocationHistory';
import Header from './header';
import * as constants from './config/constants';

class App extends Component {
    render() {
        if(constants.isLoggedIn() === "loggedIn") {
            return (
                <BrowserRouter>
                <div>
                <Header />
                <div className="App mainArea">
                <Switch>
                <Route exact={true} path='/login' component={Login} />
                <Route exact={true} path='/' component={Asset} />
                <Route exact={true} path='/asset' component={Asset} />
                <Route path='/generateQR' component={GenerateQR} />
                <Route path='/generateQRAssociates' component={GenerateQRAssociates} />
                <Route exact={true} path='/vendor' component={Vendor} />
                <Route exact={true} path='/category' component={Category} />
                <Route exact={true} path='/associates' component={Associates} />
                <Route exact={true} path='/allocation' component={Allocation} />
                <Route exact={true} path='/bulk' component={Bulk} />
                </Switch>
                </div>
                </div>
                </BrowserRouter>
                );    
        } else {
            return (
                <BrowserRouter>
                <div>
                <Header />
                <div className="App mainArea">
                <Login />
                </div>
                </div>
                </BrowserRouter>
                );
        }

    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js